import { useEffect, useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function DownloadPage() {
  const { t } = useTranslation();
  const [downloadUrl, setDownloadUrl] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setDownloadUrl(params.get('url'));
  }, []);

  const handleManualDownload = () => {
    if (downloadUrl) {
      window.location.href = downloadUrl;
    }
  };

  return (
    <Container className="text-center mt-5">
      <div className="mb-4">
        <img
          src="/images/logo_redhator_1.png"
          alt="logo_redhator"
          width="49"
        />
      </div>
      
      <h2>{t('downloadReady')}</h2>

      <p className="mt-4">{t('downloadReadyDescription')}</p>

      {downloadUrl ? (
        <p className="text-muted mt-3">
          {t('startDownloadText')}&nbsp;
          <Button
            type="button"
            variant="link"
            className="p-0 align-baseline"
            onClick={handleManualDownload}
          >
            {t('clickHere')}
          </Button>.
        </p>
      ) : (
        <p className="text-danger mt-3">{t('downloadLinkNotAvailable')}</p>
      )}

      <div className="mt-4">
        <Button as={Link} to="/inicio" variant="secondary">
          {t('goToHome')}
        </Button>
      </div>
    </Container>
  );
}

export default DownloadPage;